import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: a = 16, useVw: n, useRem: c, color: o, withColor: i, removeClassName: t, disableSSR: m, style: l, ...p }) => {
  const x = l ? { ...d, ...l } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-zaixiankefu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "24px-å¨çº¿å®¢æ"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M7.492 2.835A9.836 9.836 0 0 1 12 1.748c5.454 0 9.875 4.421 9.875 9.875v5.213a5.196 5.196 0 0 1-5.196 5.196h-3.611a.8.8 0 1 1 0-1.6h3.61a3.597 3.597 0 0 0 3.576-3.205h-2.382a2.402 2.402 0 0 1-2.401-2.401V12.69a2.935 2.935 0 0 1 2.935-2.935h1.657a8.278 8.278 0 0 0-11.84-5.497.798.798 0 0 1-.302.086A8.371 8.371 0 0 0 5.58 6.3a.798.798 0 0 1-.138.276 8.237 8.237 0 0 0-1.506 3.18h1.658A2.935 2.935 0 0 1 8.53 12.69v2.135a2.401 2.401 0 0 1-2.401 2.401H3.682c-.86 0-1.557-.697-1.557-1.557v-4.047c0-2.267.765-4.357 2.05-6.024a.798.798 0 0 1 .22-.197A9.862 9.862 0 0 1 7.264 3.01a.779.779 0 0 1 .228-.175Zm12.783 8.788v4.004h-2.403a.802.802 0 0 1-.801-.801V12.69c0-.737.598-1.335 1.335-1.335h1.865c.003.09.004.178.004.268Zm-16.546-.268a8.435 8.435 0 0 0-.004.268v4.004h2.403a.801.801 0 0 0 .801-.801V12.69c0-.738-.597-1.336-1.335-1.336H3.73Z",
        fillRule: "evenodd",
        fill: i ? r(o, 0, "#262933") : "#262933",
        datafollowfill: i ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, u = h;
export {
  u as default
};
